import { render, staticRenderFns } from "./SitToStandAnimation.vue?vue&type=template&id=69760fd4&scoped=true&"
import script from "./SitToStandAnimation.vue?vue&type=script&lang=js&"
export * from "./SitToStandAnimation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69760fd4",
  null
  
)

export default component.exports